import { baseLookup } from './lookupClient'
import { suffixOrder } from './getSuffixOptions'

export interface SuffixOption {
  value: string
  label: string
}

const getSuffixes = async () => {
  const list = await baseLookup('name-suffixes')
  return list.sort(({ value: a }, { value: b }) =>
    // If an index is defined for the server value (a and b), then compare numberically,
    // otherwise, sort alpha order (e.g. for any values the server returns that aren't defined in getSuffixOptions)
    suffixOrder[a] !== undefined && suffixOrder[b] !== undefined
      ? suffixOrder[a] - suffixOrder[b]
      : a > b
      ? 1
      : -1
  )
}

export default getSuffixes
